import { publishedAndUpdatedDate } from "../../utils/published-date";
import { Link, LazyLoadImages } from "@quintype/components";
import { renderResponsiveImage, ResponsiveBannerImage } from "../../utils/responsive-image";
import SocialShare from "../common/SocialShare";
import React, { useState } from "react";
import { CloseIcon } from "../Icons/Icon";
const StoryTextElement = ({ element }) => {
  let text = element.text;
  text = text.replace(
    /<a/g,
    '<a target="_blank" rel="noopener noreferrer" class="text-primary" style="font-variation-settings: \'slnt\' -6"'
  );

  return (
    <div
      key={element.id}
      className="flex flex-col gap-[24px] text-[18px] font-[400] leading-[170%] tablet:text-[17px] story_bulletin mobile:text-[17px]"
      dangerouslySetInnerHTML={{
        __html: text,
      }}
    />
  );
};

const StorySummary = ({ summary }) => {
  summary = summary.replace(/<p>/g, '<li class="text-[18px] font-[400] leading-[28px] mobile:text-[17px]">');
  summary = summary.replace(/<\/p>/g, "</li>");
  summary = summary.replace(
    /<li>/g,

    '<ul class="list-disc list-inside">'
  );
  summary = summary.replace(/<\/li>/g, "</ul>");

  return (
    <div
      className=" font-inter text-[18px] leading-[28px] tablet:text-base"
      style={{ fontVariationSettings: "'slnt' -6" }}
      dangerouslySetInnerHTML={{ __html: summary }}
    />
  );
};

const HeroImageWithCaption = ({ story }) => {
  const [isZoomed, setIsZoomed] = useState(false);

  const handleImageClick = () => {
    setIsZoomed(true);
  };

  const closeZoom = () => {
    setIsZoomed(false);
  };

  return (
    <>
      <figure className="flex flex-col gap-2 max-w-[746px]">
        {/* Single responsive hero image - no lazy loading, high priority */}
        {story["hero-image-s3-key"] && (
          <div className="cursor-zoom-in" onClick={handleImageClick}>
            <ResponsiveBannerImage
              slug={story["hero-image-s3-key"]}
              alt={story["hero-image-caption"]}
              width="610"
              quality="75"
              loading="eager"
              fetchpriority="high"
            />
          </div>
        )}

        <figcaption className="flex justify-end text-sm italic font-normal text-[#9c9c9c]">
          {story?.["hero-image-caption"]}
        </figcaption>
      </figure>

      {/* Zoom Modal */}
      {isZoomed && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4"
          onClick={closeZoom}
        >
          <div className="relative max-w-6xl w-full">
            <button
              onClick={closeZoom}
              className="absolute top-4 right-4 text-white hover:text-gray-300 p-2 rounded-full bg-black bg-opacity-50"
            >
              <CloseIcon />
            </button>

            <LazyLoadImages>
              <ResponsiveBannerImage
                slug={story["hero-image-s3-key"]}
                alt={story["hero-image-caption"]}
                width="1200"
                quality="100"
                isZoom={true}
              />
            </LazyLoadImages>

            {story?.["hero-image-caption"] && (
              <p className="mt-2 text-white text-sm italic text-center">{story["hero-image-caption"]}</p>
            )}
          </div>
        </div>
      )}
    </>
  );
};
// const HeroImageWithCaption = ({ story }) => {
//   // const imageElement = renderResponsiveImage(story["hero-image-s3-key"], story["hero-image-caption"], 640);
//   return (
//     <figure
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         gap: "8px",
//         maxWidth: "746px",
//       }}
//     >
//       {/* <div style={{ height: "auto" }}>{imageElement}</div> */}

//       <div className="hidden sm:block">
//         <LazyLoadImages>
//           <ResponsiveBannerImage
//             slug={story["hero-image-s3-key"]}
//             alt={story["hero-image-caption"]}
//             width="610"
//             quality="50"
//           />
//         </LazyLoadImages>
//       </div>

//       {/* Mobile image */}
//       <div className="block sm:hidden">
//         <LazyLoadImages>
//           <ResponsiveBannerImage
//             slug={story["hero-image-s3-key"]}
//             alt={story["hero-image-caption"]}
//             width="310"
//             quality="50"
//           />
//         </LazyLoadImages>
//       </div>

//       <figcaption
//         style={{
//           display: "flex",
//           justifyContent: "end",
//           fontSize: "12px",
//           fontStyle: "italic",
//           fontWeight: "400",
//           color: "#9c9c9c",
//         }}
//       >
//         {story?.["hero-image-caption"]}
//       </figcaption>
//     </figure>
//   );
// };

const AuthorElement = ({ story }) => {
  return (
    <div className="flex flex-row">
      <div className="flex flex-col">
        <Link href={`/author/${story?.["author-id"]}/${story?.authors[0].slug}`}>
          <p className="text-[14px] font-[600] uppercase">{story?.["author-name"]}</p>
        </Link>
        <p className=" text-sm font-[400]">{publishedAndUpdatedDate(story?.["published-at"], story?.["updated-at"])}</p>
      </div>
    </div>
  );
};

// const ImageElement = ({ element }) => {
//   const imageElement = renderResponsiveImage(element["image-s3-key"], element["title"], 640);
//   return (
//     <div key={element.id}>
//       <div className="h-[auto] mobile:hidden">{imageElement}</div>
//       <div className="hidden h-full w-full mobile:block">{imageElement}</div>
//       {/* <div className="hidden h-[343px] w-[229px] mobile:block">{imageElement}</div> */}
//       <div className="flex justify-end">
//         <span className="text-[12px] font-[400] italic text-[#9c9c9c]">{element["title"]}</span>
//       </div>
//     </div>
//   );
// };

const ImageElement = ({ element, key, story }) => {
  //zoom functionality
  const [isZoomed, setIsZoomed] = useState(false);

  const handleImageClick = () => {
    setIsZoomed(true);
  };

  const closeZoom = () => {
    setIsZoomed(false);
  };

  return (
    <>
      <div key={element.id}>
        <div className="cursor-zoom-in" onClick={handleImageClick}>
          <LazyLoadImages>
            <ResponsiveBannerImage slug={element["image-s3-key"]} alt={element["title"]} width="1220" quality="100" />
          </LazyLoadImages>
        </div>
        <div className="flex justify-end">
          <span className="text-[12px] font-[400] italic text-[#9c9c9c]">{element["title"]}</span>
        </div>
      </div>

      {/* Zoom Modal */}
      {isZoomed && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4"
          onClick={closeZoom}
        >
          <div className="relative max-w-6xl w-full">
            <button
              onClick={closeZoom}
              className="absolute top-4 right-4 text-white hover:text-gray-300 p-2 rounded-full bg-black bg-opacity-50"
            >
              <CloseIcon />
            </button>

            <LazyLoadImages>
              <ResponsiveBannerImage
                slug={element["image-s3-key"]}
                alt={element["title"]}
                width="1200"
                quality="100"
                isZoom={true}
              />
            </LazyLoadImages>

            {element["title"] && <p className="mt-2 text-white text-sm italic text-center">{element["title"]}</p>}
          </div>
        </div>
      )}
    </>
  );
};

// const ImageElement = ({ element, key, story }) => {
//   return (
//     <div key={element.id}>
//       <div>
//         <LazyLoadImages>
//           <ResponsiveBannerImage slug={element["image-s3-key"]} alt={element["title"]} width="610" quality="50" />
//         </LazyLoadImages>
//       </div>
//       <div className="flex justify-end">
//         <span className="text-[12px] font-[400] italic text-[#9c9c9c]">{element["title"]}</span>
//       </div>
//     </div>
//   );
// };
const QuouteElement = ({ element }) => {
  return (
    <div
      className={`quote_divider flex dark:text-[#9c9c9c] mobile:text-lg`}
      key={element.id}
      dangerouslySetInnerHTML={{ __html: element.text }}
    />
  );
};

const YoutubeEmbed = ({ element }) => {
  const videoId =
    element?.embed_url?.split("/").pop() || new URL(element.url).searchParams.get("v") || element.url.split("/").pop();
  return (
    <div key={element.id}>
      <div className="flex w-[100%] flex-col gap-[8px]">
        <iframe
          width={"100%"}
          height={"100%"}
          style={{ aspectRatio: 3 / 2 }}
          src={`https://www.youtube.com/embed/${videoId}`}
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

const TweeterEmbed = ({ element }) => {
  let decodeCode = atob(element["embed-js"]);

  const srcValue = decodeCode.split('src="')[1].split('"')[0];

  return (
    <div key={element.id}>
      <div className="flex flex-col gap-[8px] ">
        <div style={{ width: "40px !important" }} dangerouslySetInnerHTML={{ __html: decodeCode }} />
        {/* <Tweet id={element.metadata.tweet_id} key={element.id} /> */}
      </div>
    </div>
  );
};

const RenderArticleContent = ({ story }) => {
  return (
    <div className="flex flex-col gap-[24px] p-[24px] mobile:px-[0] ">
      {story?.cards.map((card, index) => {
        return card["story-elements"].map((element, index) => {
          if (element.type === "text" && element.subtype === null) {
            return <StoryTextElement element={element} key={element.id} />;
          } else if (element.type === "image") {
            return <ImageElement element={element} key={element.id} story={story} />;
          } else if (element.type === "text" && element.subtype === "quote") {
            return <QuouteElement element={element} key={element.id} />;
          } else if (element.type === "text" && element.subtype === "blockquote") {
            return <QuouteElement element={element} key={element.id} />;
          } else if (element.type === "youtube-video" || element.type === "youtube-video") {
            return <YoutubeEmbed element={element} key={element.id} />;
          } else if (element.type === "jsembed") {
            return <TweeterEmbed element={element} key={element.id} />;
          }
        });
      })}
      <div className="flex items-center gap-3">
        <SocialShare url={story.url} headline={story?.headline} story={story} />
      </div>
    </div>
  );
};

const RenderTag = ({ story }) => {
  return (
    <div className="flex flex-col gap-6 px-[24px] mobile:px-[0]">
      <div className="flex flex-wrap items-center gap-[12px]">
        <span className=" text-[18px] font-[500] leading-[140%] text-primary mobile:text-base">Tags</span>
        {story?.tags?.map((tag) => (
          <li className="list-none" key={tag.id}>
            <Link
              className="rounded-sm bg-[#f1f0ef] px-3 py-1 text-sm font-[400] text-grey dark:bg-[#444] dark:text-amber-50"
              href={`/topic/${tag.name}`}
            >
              {tag.name}
            </Link>
          </li>
        ))}
      </div>
    </div>
  );
};

const RenderAuthorBio = ({ story }) => {
  return (
    <div className="mb-5 px-[24px] italic text-primary mobile:px-[0]">
      <p className="text-md font-[400] text-primary">{story?.authors[0]?.bio.replace(/<[^>]*>/g, "")}</p>
    </div>
  );
};

const RenderWhatsAppChannel = () => {
  return (
    <div className="mt-5 flex px-[24px] mobile:px-0">
      <div className="border-y-[2px] py-3 mobile:px-0">
        <Link target="_blank" href="https://www.whatsapp.com/channel/0029VaLLOHZBadmhCn6IQI22">
          <div className="flex items-center gap-2">
            <img
              src={"https://articleimage.sgp1.cdn.digitaloceanspaces.com/articlespace/assets/whatsapp.png"}
              alt="whatsapp"
              width={20}
              height={20}
            />
            <p>
              Join our <span className="text-green-600">WhatsApp channel</span> - no spam, only sharp analysis
            </p>
            <br />
          </div>
        </Link>
      </div>
    </div>
  );
};
export {
  StorySummary,
  RenderWhatsAppChannel,
  HeroImageWithCaption,
  AuthorElement,
  RenderArticleContent,
  RenderTag,
  RenderAuthorBio,
};
